import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GolfRoutingModule } from './golf-routing.module';
import { GolfHeadToHeadPageComponent } from './golf-head-to-head-page/golf-head-to-head-page.component';
import { GolfRankingsPageComponent } from './golf-rankings-page/golf-rankings-page.component';
import { GolfTournamentPageComponent } from './golf-tournament-page/golf-tournament-page.component';
import { SidebarModule } from '../sidebar/sidebar.module';
import { GeneralModule } from '../general/general.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { GolfTournamentBlockComponent } from './golf-tournament-block/golf-tournament-block.component';
import { BookPipesModule } from '../book-pipes/book-pipes.module';
import { TemperaturePipesModule } from '../temperature-pipes/temperature-pipes.module';
import { OddsDisclaimerComponent } from '../general/odds-disclaimer/odds-disclaimer.component';



@NgModule({
  declarations: [
    GolfHeadToHeadPageComponent,
    GolfRankingsPageComponent,
    GolfTournamentPageComponent,
    GolfTournamentBlockComponent,
  ],
  imports: [
    CommonModule,
    GolfRoutingModule,
    SidebarModule,
    GeneralModule,
    FontAwesomeModule,
    FormsModule,
    BookPipesModule,
    TemperaturePipesModule,
	  OddsDisclaimerComponent,
  ]
})
export class GolfModule { }
